/**
 * DevExtreme (esm/__internal/grids/grid_core/context_menu/const.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const CONTEXT_MENU_MOVE_PREVIOUS_ICON_NAME = "arrowleft";
export const CONTEXT_MENU_MOVE_NEXT_ICON_NAME = "arrowright";
